// @flow

import type { State } from './state'

export const actions = {
  async start ({
    dispatch,
    commit,
    getters
  }: { dispatch: any, commit: any, getters: any }) {
    if (getters.isShowingOpenChat) {
      await commit('setWelcomeMessage', null)
      await dispatch('resetOpenChat')
    }
    await dispatch('open')
  },
  toggleOpen ({
    state,
    dispatch
  }: { state: State, dispatch: any }) {
    if (state.isOpen) {
      dispatch('close')
    } else {
      dispatch('open')
    }
  },
  open ({
    state,
    commit,
    getters
  }: { state: State, commit: any, getters: any }) {
    if (state.isOpen) return

    commit('setOpen', true)
    if (!getters.isShowingOpenChat) commit('setHasChatBubbleBeenOpened', true)
  },
  close ({
    state,
    dispatch,
    commit
  }: { state: State, dispatch: any, commit: any }) {
    if (!state.isOpen) return

    commit('setOpen', false)
    dispatch('clearClientSideMessages')
  }
}
